<div style="width:500px;">
  <div style="width:99%;">
    <span> <button class="btn btn border" (click)="saveOfficeType()" [disabled]="!form.dirty">Spara</button> <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
    <br>
    <hr />
    <form [formGroup]="form">
      <div class="row">
        <div class="col-md-5">
          <label>
            Ämbetstyp Sortering
          </label>
          <input id="sort" type="text" class="form-control form-control-sm" formControlName="sort">
        </div>
      </div>
      <div class="row">
        <div class="col-md-5">
          <label>
            Ämbetstyp Förkortning
          </label>
          <input id="abbreviation" type="text" class="form-control form-control-sm" formControlName="abbreviation">
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <label>
            Ämbetstyp Namn
          </label>
          <input id="name" type="text" class="form-control form-control-sm" formControlName="name">
        </div>
      </div>
    </form>
  </div>
</div>